import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=0421191e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0421191e')) {
      api.createRecord('0421191e', component.options)
    } else {
      api.reload('0421191e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=0421191e&", function () {
      api.rerender('0421191e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CFwCOObSn94H/JS/pricehelp.vue"
export default component.exports